import { arrayOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type { GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsResult } from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsResult>({
    results: arrayOf(objectOf({ dimension: string, type: string, activeVariantCount: number })),
  });
